export default {
  count:10,
  top: {
    count: 10,
  },
  styles: {
    width: 2,
    color: '#2b2a49',
  },
  offset: {
    top: 30,
    right: 30,
    bottom: 30,
    left: 30,
  },
};
